import React, { useEffect, useState } from "react";

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${remainingSeconds
    .toString()
    .padStart(2, "0")}`;
};

const ResendTimer = ({ handleResendActive }) => {
  const [timer, setTimer] = useState(600);

  useEffect(() => {
    const countdown = setInterval(() => {
      setTimer((prevTimer) => {
        if (prevTimer <= 1) {
          clearInterval(countdown);
          handleResendActive();
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);

    return () => clearInterval(countdown);
  }, [handleResendActive]);

  return (
    <div>
      Resend OTP In: <span>{formatTime(timer)}</span>
    </div>
  );
};

export default ResendTimer;
